import {
    FETCH_ACTIVITY_LOG
} from "../../actions/actionTypes";


const fetchActivityLogReducer = (logs, payload) => {
    let newLogs = payload.appendData ? [ ...logs ] : []
    
    for(let log of payload.logs){
        newLogs.push(log.logId);
    }
    let uniqueIds = [...new Set(newLogs)];
    return uniqueIds;
}


const activityLogsOrderReducer = (state=[], action) => {
    let logs = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_ACTIVITY_LOG:
                return fetchActivityLogReducer(logs, action.payload);
            default:
                return logs;
        }
    }
    return logs;
}

export default activityLogsOrderReducer;